'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ramda = require('ramda');

var _functional_utility = require('common-utilities/src/functional_utility');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UID = {
  current: 0,
  getNew: function getNew() {
    this.current++;
    return this.current;
  }
};

HTMLElement.prototype.pseudoStyle = function (element, prop, value) {

  var sheetId = "pseudoStyles";
  var head = document.head || document.getElementsByTagName('head')[0];
  var sheet = document.getElementById(sheetId) || document.createElement('style');
  sheet.id = sheetId;
  var className = "pseudoStyle" + UID.getNew();

  this.className += " " + className;

  sheet.innerHTML += " ." + className + ":" + element + "{" + prop + ":" + value + "}";
  head.appendChild(sheet);
  return this;
};

var TableComponent = function (_React$Component) {
  _inherits(TableComponent, _React$Component);

  function TableComponent(props) {
    _classCallCheck(this, TableComponent);

    var _this = _possibleConstructorReturn(this, (TableComponent.__proto__ || Object.getPrototypeOf(TableComponent)).call(this, props));

    _this.state = {
      scrollImageClassName: ""
    };
    _this.removeScrollImage = _this.removeScrollImage.bind(_this);
    _this.hasHorizontalScrollbar = _this.hasHorizontalScrollbar.bind(_this);
    _this.setPseudoStyling = _this.setPseudoStyling.bind(_this);
    _this.imageDim = 100;
    return _this;
  }

  _createClass(TableComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      return this.displayScrollImage();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      return this.displayScrollImage(prevProps);
    }
  }, {
    key: 'displayScrollImage',
    value: function displayScrollImage(prevProps) {
      var _props = this.props,
          tableBodyTest = _props.tableBodyTest,
          activeTab = _props.activeTab,
          activeReturnType = _props.activeReturnType,
          breakpoint = _props.breakpoint;
      var scrollImageClassName = this.state.scrollImageClassName;

      if (breakpoint > 3) {
        return false;
      }

      if (!this.hasHorizontalScrollbar()) {
        return false;
      }

      if ((0, _functional_utility.isNilOrEmpty)(prevProps) || scrollImageClassName === "" && !(0, _ramda.isNil)(this[tableBodyTest].offsetParent) || prevProps.activeTab !== activeTab || prevProps.activeReturnType !== activeReturnType) {
        this.addScrollImage();
        this.addScrollContainerEventListener();
      }
    }
  }, {
    key: 'hasHorizontalScrollbar',
    value: function hasHorizontalScrollbar() {
      var tableBodyTest = this.props.tableBodyTest;
      // Account for IE bug where scrollWidth is 1px higher than clientWidth.

      return this[tableBodyTest].scrollWidth - this[tableBodyTest].clientWidth > 1;
    }
  }, {
    key: 'removeScrollImage',
    value: function removeScrollImage(e) {
      var _this2 = this;

      e.preventDefault();
      if (this.state.scrollImageClassName === "hide-scroll-image") {
        return false;
      }

      this.setState({
        scrollImageClassName: "hide-scroll-image"
      }, function () {
        return _this2[_this2.props.tableBodyTest].removeEventListener("scroll", _this2.removeScrollImage, true);
      });
    }
  }, {
    key: 'addScrollImage',
    value: function addScrollImage() {
      var _this3 = this;

      this.setState({
        scrollImageClassName: "scroll-indicator"
      }, function () {
        _this3.setPseudoStyling();
      });
    }
  }, {
    key: 'setPseudoStyling',
    value: function setPseudoStyling() {
      this[this.props.tableBodyTest].pseudoStyle("before", "margin-top", (this[this.props.tableBodyTest].offsetHeight - this.imageDim) / 2 + "px");
      this[this.props.tableBodyTest].pseudoStyle("before", "margin-left", (this[this.props.tableBodyTest].offsetWidth - this.imageDim) / 2 + "px");
    }
  }, {
    key: 'addScrollContainerEventListener',
    value: function addScrollContainerEventListener() {
      if (this.props.breakpoint <= 3 && !(0, _ramda.isNil)(this[this.props.tableBodyTest])) {
        this[this.props.tableBodyTest].addEventListener("scroll", this.removeScrollImage, true);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      return _react2.default.createElement(
        'div',
        { className: 'pdp-table print-top-margin-35 print-page-break' },
        !(0, _ramda.isNil)(this.props.printTitle) && _react2.default.createElement(
          'h3',
          { 'data-testid': 'print-' + this.props.printTitle + '-title', className: 'print-display', style: { "display": "none" } },
          'Performance - ',
          this.props.printTitle
        ),
        _react2.default.createElement(
          'p',
          { 'data-testid': 'print-' + this.props.printTitle + '-date', className: 'print-display', style: { "display": "none" } },
          this.props.date
        ),
        _react2.default.createElement(
          'div',
          { className: 'table-responsive border-none ' + this.state.scrollImageClassName,
            ref: function ref(el) {
              _this4[_this4.props.tableBodyTest] = el;
            } },
          _react2.default.createElement(
            'table',
            { className: 'table position-relative print-fixed-table ' + (this.props.tableBodyTest === "portfolio-all-holdings-body" ? "print-font-size-10" : ""),
              'aria-describedby': !(0, _functional_utility.isNilOrEmpty)(this.props.ariaLabelledby) ? this.props.ariaLabelledby : null },
            (0, _functional_utility.isNilOrEmpty)(this.props.tableHeaders) ? null : _react2.default.createElement(
              'thead',
              null,
              _react2.default.createElement(
                'tr',
                { className: 'font-black-variant tag text-left border-bottom-1 border-card-title-border', style: this.props.tableHeadersStyle },
                this.props.tableHeaders
              )
            ),
            _react2.default.createElement(
              'tbody',
              { 'data-testid': this.props.tableBodyTest },
              this.props.tableRows
            )
          )
        )
      );
    }
  }]);

  return TableComponent;
}(_react2.default.Component);

exports.default = TableComponent;